if(!window.smylumeReviewReadMoreReady){
  window.smylumeReviewReadMoreReady=true;
  const fallbackReviews=new WeakMap();
  const fullTexts=new WeakMap();
  const syncPreviews=()=>{
    document.querySelectorAll('.sm-inline-reviews').forEach(wrapper=>{
      const expanded=wrapper.classList.contains('sm-review-expanded');
      const texts=[...wrapper.querySelectorAll('.jdgm-text p,.sm-review-preview-text')];
      let activeLong=false;
      texts.forEach(text=>{
        let full=fullTexts.get(text);
        if(!full){full=text.textContent.trim();if(!full)return;fullTexts.set(text,full);}
        const words=full.split(/\s+/);let preview='';
        for(const word of words){if(preview.length+word.length+1>160&&preview)break;preview+=(preview?' ':'')+word;}
        const long=preview.length<full.length;
        const value=expanded||!long?full:preview+'…';
        if(text.textContent!==value)text.textContent=value;
        if(!text.closest('.jdgm-carousel-item')||text.closest('.jdgm-carousel-item').classList.contains('active'))activeLong=activeLong||long;
      });
      const button=wrapper.querySelector('.sm-inline-readmore');
      if(button){button.hidden=!activeLong;button.setAttribute('aria-expanded',String(expanded));const label=expanded?'Read less':'Read more';if(button.textContent!==label)button.textContent=label;}
    });
  };
  const initFallbacks=()=>{
    document.querySelectorAll('.sm-review-fallback').forEach(fallback=>{
      if(fallback.dataset.ready)return;
      const reviews=[...document.querySelectorAll('#customer-reviews .jdgm-testimonial')];
      if(!reviews.length)return;
      fallback.dataset.ready='true';
      const wrapper=fallback.closest('.sm-inline-reviews');let index=0;
      const show=()=>{
        const review=reviews[index];fallbackReviews.set(wrapper,review);
        let stars=fallback.querySelector('.sm-review-preview-stars');
        if(!stars){stars=document.createElement('div');stars.className='sm-review-preview-stars';fallback.prepend(stars)}
        const sourceStars=review.querySelector('.jdgm-stars');
        stars.replaceChildren(...(sourceStars?[sourceStars.cloneNode(true)]:[]));
        fullTexts.delete(fallback.querySelector('.sm-review-preview-text'));
        fallback.querySelector('.sm-review-preview-text').textContent=review.querySelector('.jdgm-text')?.textContent.trim()||'';
        fallback.querySelector('.sm-review-preview-author').textContent=review.querySelector('.jdgm-reviewer-name')?.textContent.trim()||'';
      };
      fallback.querySelector('[data-review-prev]').addEventListener('click',()=>{index=(index+reviews.length-1)%reviews.length;show()});
      fallback.querySelector('[data-review-next]').addEventListener('click',()=>{index=(index+1)%reviews.length;show()});
      show();
    });
  };
  initFallbacks();
  syncPreviews();
  const observer=new MutationObserver(()=>{initFallbacks();syncPreviews();});observer.observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['class']});
  document.addEventListener('click',event=>{
    const more=event.target.closest('.sm-inline-readmore');
    if(more){
      const wrapper=more.closest('.sm-inline-reviews');
      wrapper.classList.toggle('sm-review-expanded');
      syncPreviews();
    }
    const close=event.target.closest('.sm-inline-review-close');
    if(close)close.closest('dialog').close();
    if(event.target.matches('.sm-inline-review-dialog')){
      const r=event.target.getBoundingClientRect();
      if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)event.target.close();
    }
  });
}
